import type { SxProps, Theme } from '@mui/material';

export const learningContentDetailsClassNames = {
  root: 'skill-learn-details',
  columns: 'skill-learn-columns',
  sectionList: 'skill-learn-section-list',
  resources: 'skill-learn-resources',
  note: 'skill-learn-note',
  check: 'skill-learn-check',
  transcript: 'skill-learn-transcript',
};

export const learningContentDetailsStyles = {
  root: () =>
    ({
      alignSelf: 'end',
      display: 'grid',
      gap: '12px',
      marginTop: '12px',
      color: '#374151',
      fontSize: '16px',
      lineHeight: 1.32,
      '& h4': {
        margin: '0 0 8px',
        color: '#111827',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: 1.25,
      },
      '& ul, & ol': {
        display: 'grid',
        gap: '4px',
        margin: 0,
        paddingLeft: '20px',
      },
    }) as SxProps<Theme>,

  columns: (theme: Theme) =>
    ({
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '14px',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    }) as SxProps<Theme>,

  sectionList: () =>
    ({
      display: 'grid',
      gap: '12px',
      '& p': {
        margin: 0,
      },
    }) as SxProps<Theme>,

  resources: () =>
    ({
      display: 'grid',
      gap: '8px',
      '& p': {
        margin: 0,
      },
      '& a, & .MuiLink-root': {
        color: '#0769b3',
        fontWeight: 'inherit',
        textDecoration: 'none',
      },
      '& a:hover, & a:focus-visible, & .MuiLink-root:hover, & .MuiLink-root:focus-visible': {
        color: '#0769b3',
        textDecoration: 'none',
      },
    }) as SxProps<Theme>,

  resourcesHeading: () =>
    ({
      margin: '0 0 8px',
      color: '#111827',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: 1.25,
    }) as SxProps<Theme>,

  resourceList: () =>
    ({
      margin: 0,
      paddingLeft: '20px',
    }) as SxProps<Theme>,

  note: () =>
    ({
      margin: 0,
      borderLeft: '3px solid #098beb',
      paddingLeft: '12px',
      color: '#4b5563',
    }) as SxProps<Theme>,

  check: () =>
    ({
      margin: 0,
      borderRadius: '8px',
      padding: '10px 12px',
      background: '#f3f8ee',
      color: '#3f7f12',
      fontWeight: 600,
    }) as SxProps<Theme>,

  transcript: () =>
    ({
      borderTop: '1px solid #e5e7eb',
      paddingTop: '10px',
      '& p': {
        margin: 0,
      },
      '& summary': {
        width: 'fit-content',
        color: '#0769b3',
        fontWeight: 600,
        cursor: 'pointer',
      },
      '& div': {
        display: 'grid',
        gap: '10px',
        marginTop: '10px',
      },
    }) as SxProps<Theme>,
};
